import { render, staticRenderFns } from "./LangOptions.vue?vue&type=template&id=25006a21"
import script from "./LangOptions.vue?vue&type=script&lang=js"
export * from "./LangOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports